
import { PrayerTime } from "@/types/page";

interface ContentFormat {
  type: string;
  data: any;
}

export function useContentFormatting() {
  // Function to save according to different content formats
  const formatContentForSaving = (
    prayerTimes: PrayerTime[],
    blockTitle: string,
    animationSpeed: number,
    isLegacyFormat: boolean,
    originalContentFormat: ContentFormat | null
  ) => {
    // Clean prayer times array by ensuring string time values
    const cleanPrayerTimes = prayerTimes.map(pt => {
      // Ensure all time values are strings and convert if needed
      const time = typeof pt.time === 'string' ? pt.time : String(pt.time);
      
      // Omit the legacyFieldName property for clean data
      const { legacyFieldName, ...rest } = pt as any;
      return {
        ...rest,
        time: time,
        // Ensure ID is always a string
        id: pt.id.toString()
      };
    });
    
    // Based on the original format, determine what to save to the page content
    let formattedContent: Record<string, any> = {};
    
    if (isLegacyFormat && originalContentFormat?.type === "legacy") {
      console.log("Saving in legacy format");
      // In legacy format, we save each prayer time as a separate field
      
      formattedContent = {};
      
      // Clear all legacy fields first to ensure removed times are actually gone
      if (originalContentFormat?.data) {
        for (const field in originalContentFormat.data) {
          if (typeof originalContentFormat.data[field] === 'string') {
            formattedContent[field] = '';
          }
        }
      }
      
      // Then save only the active ones
      prayerTimes.forEach(pt => {
        const legacyFieldName = (pt as any).legacyFieldName;
        if (legacyFieldName) {
          console.log(`Saving legacy field ${legacyFieldName}:`, pt.time);
          formattedContent[legacyFieldName] = String(pt.time);
        }
      });
      
      // Always save the title and animation speed
      formattedContent.blockTitle = blockTitle;
      formattedContent.animationSpeed = animationSpeed;
    } 
    else if (originalContentFormat?.type === "array") {
      console.log("Saving in array format");
      // Save as array format
      console.log("Saving prayer times array:", cleanPrayerTimes);
      formattedContent.prayerTimes = cleanPrayerTimes;
      formattedContent.blockTitle = blockTitle;
      formattedContent.animationSpeed = animationSpeed;
    }
    else if (originalContentFormat?.type === "sections") {
      console.log("Saving in sections format");
      // When saving to sections format, we need to update the existing sections
      const updatedSections = originalContentFormat.data.sections.map((section: any) => {
        if (section.id === "prayer-times" || !section.id) {
          return {
            ...section,
            title: blockTitle || section.title,
            prayerTimes: cleanPrayerTimes
          };
        }
        return section;
      });
      
      console.log("Saving updated sections:", updatedSections);
      formattedContent.sections = updatedSections;
      formattedContent.blockTitle = blockTitle;
      formattedContent.animationSpeed = animationSpeed;
    }
    else {
      console.log("Saving in default array format");
      // Default save as array format (new pages)
      console.log("Saving prayer times array:", cleanPrayerTimes);
      formattedContent.prayerTimes = cleanPrayerTimes;
      formattedContent.blockTitle = blockTitle;
      formattedContent.animationSpeed = animationSpeed;
    }
    
    return formattedContent;
  };

  return {
    formatContentForSaving
  };
}
